import React, { useState, useEffect } from 'react';
import Select from 'components/shared/select';

const LanguageSelection = ({ content, onChange }) => {
  const [language, setLanguage] = useState();
  const defaultLanguage = 'en';

  useEffect(() => {
    if (
      content.requested_language !== undefined &&
      content.requested_language !== null
    ) {
      setLanguage(content.requested_language);
    } else {
      setLanguage(defaultLanguage);
    }
  }, [content]);

  const onLanguageChange = e => {
    setLanguage(e.target.value);
    onChange({
      requested_language: e.target.value,
    });
  };
  return (
    <>
      <div className="mt-16 mb-16" id="requested-language">
        <h3 className="automated-analysis-language-title">
          {t('automated_analysis.language_selection.title')}
        </h3>
        <form>
          <Select
            value={language}
            className="w-319"
            onChange={e => {
              onLanguageChange(e);
            }}
            id="requested-language-select"
            ariaLabel={t('automated_analysis.language_selection.label')}
          >
            {content.language_list.map(option => (
              <option key={option.code} value={option.code}>
                {option.name}
              </option>
            ))}
          </Select>
        </form>
      </div>
    </>
  );
};

export default LanguageSelection;
